export const AppIcon = require('./app-icon.webp');
export const Hexagon = require('./hexagon.webp');
export const Logo = require('./logo.webp');
export const HexagonStroke = require('./hexagon-stroke.webp');
export const HexagonStrokeActive = require('./hexagon-stroke-active.webp');
